export type PageType = "order/setup" | "ap-order";

export const getProgramSelectorUrl = (
  propertyId: string,
  pageType: PageType,
  hqId: string
) => `/customer/hq/${hqId}/program-selector/${propertyId}?pageType=${pageType}`;
